import React, {FC} from "react"
import {TextModel} from "models/Text"
import connect from "./connect"
import {FilterFacet} from "../../../models/Filter"
import TabbedFilter from "../tabbedFilter"
import {FiltersPanelContainer, PaddedWrapper} from "../components"
import {SORT} from "../../../config/constants"

import AlphabeticallySortedTabbedFilter from "../alphabeticallySortedTabbedFilter"
import NoOptionsText from "../noOptionsText"
import ShowFiltersText from "../showFiltersText"
import {TabbedFilterContainer} from "../tabbedFiltersPanel/components"
import FilterSearchBar from "../tabbedFilterSearch"
import SortTabbedFilter from "../sortTabbedFilter"

interface FacetDetailsProps extends Pick<FilterFacet, "disabled" | "name" | "facets" | "displayName"> {
    showLoadingText?: boolean
    text: TextModel
    sortFiltersAlphabatically: boolean
    compositeFilter: boolean
    freeTextFiltersList: string[]
    setFreeTextFilterSearch: (e: React.SyntheticEvent, filterName: string) => void
    clearFreeTextSearchForFilter: (filterName: string) => void
    freeTextFilterSearch: {[key: string]: string}
}

const FilterDetails: FC<FacetDetailsProps> = ({
    displayName,
    name,
    showLoadingText,
    disabled,
    facets,
    text,
    sortFiltersAlphabatically,
    compositeFilter,
    freeTextFiltersList,
    setFreeTextFilterSearch,
    clearFreeTextSearchForFilter,
    freeTextFilterSearch,
}) => {
    if (disabled || !facets) return <NoOptionsText text={text} />

    if (showLoadingText) {
        return (
            <FiltersPanelContainer data-testid="plp-tabbed-facets-panel">
                <PaddedWrapper>
                    <ShowFiltersText>{text.labels.loadingResults}</ShowFiltersText>
                </PaddedWrapper>
            </FiltersPanelContainer>
        )
    }

    if (name === SORT) return <SortTabbedFilter />

    return sortFiltersAlphabatically || compositeFilter ? (
        <AlphabeticallySortedTabbedFilter filterName={name} filterDisplayName={displayName} />
    ) : (
        <FiltersPanelContainer data-testid="plp-tabbed-facets-panel">
            <TabbedFilterContainer>
                {(freeTextFiltersList.includes(name) || compositeFilter) && (
                    <FilterSearchBar
                        setFreeTextFilterSearch={setFreeTextFilterSearch}
                        clearFreeTextSearchForFilter={clearFreeTextSearchForFilter}
                        freeTextFilterSearch={freeTextFilterSearch}
                        filterName={name}
                        text={text}
                        filterDisplayName={displayName}
                    />
                )}
                {facets.map((filter, index) => (
                    <TabbedFilter
                        key={filter}
                        filterName={filter}
                        isTabbedFilter
                        facetName={name}
                        tabAutoFocus={
                            index === 0 &&
                            (freeTextFilterSearch[name] === undefined || freeTextFilterSearch[name] === "")
                        }
                    />
                ))}
            </TabbedFilterContainer>
        </FiltersPanelContainer>
    )
}

export default connect(FilterDetails)
